export default __webpack_public_path__ + "static/media/spr-lesson-builder-dark.4c66acc3.jpg";